require('./style.less');

var Marionette = require('marionette'),
    HeaderView = require('./header/view'),
    SearchView = require('./searchView/view'),
    ResultsView = require('./resultsView/view'),
    SearchNotAllowedView = require('./searchNotAllowedView/view'),
    LoadingPredefinedSearchesView = require('./loadingPredefinedSearches/view');



module.exports = Marionette.LayoutView.extend({

    initialize: function( options ) {

        this.channel = options.channel;
    },

    template: require('./template.hbs'),

    regions: {
        headerRegion:               '#fr-header',
        searchRegion:               '#fr-search',
        resultsRegion:              '#find-and-redact-results'
    },

    serializeData: function() {

        return {
            paneId: 'find-and-redact'
        };

    },

    onBeforeShow: function() {

        var state = this.channel.request('state');

        // Can't have the spinner in the header and show it using on before show
        this.headerRegion.show( new HeaderView({
            channel: this.channel
        }));


        /**
         * If no available note types, disallow any search and show a warning view.
         * Can put here b/c there will not the ability to search/research.
         */
        var creatableNotesHelper = this.channel.request('creatableNoteTypesHelper');

        if ( creatableNotesHelper.allFindAndRedactNoteTypesDisabled() ) {
            this.searchRegion.show( new SearchNotAllowedView() );
            return;
        }


        this.showBodyRegions();


    },


    /**
     * The searchRegion and bodyResults regions
     * Always want a header section always in DOM to show spinner ( can't be shown if not in DOM yet ).
     * Don't need for clear (spinner would be removed but it's a smoother transition )
     * Assumes there are creatable note types so we can do a search.
     * TODO: should be it's on region
     */
    showBodyRegions: function() {

        var channel = this.channel,
            state = channel.request('state'),
            searchPerformed = state.get('searchPerformed');

        // Search:

        if ( !searchPerformed ) {

            // No predefined searches
            if ( state.get('searches').length < 1 ) {


                this.searchRegion.show( new SearchView({
                    channel: channel,

                    model: channel.request('getNewSearchModel'),

                    onSubmit: function( searchModel ) {

                        this.channel.trigger( 'findAndRedact:search', searchModel );
                    }.bind( this )

                }));

            } else {

                /**
                 * Predefined searches: in current WF wouldn't have been searched yet.
                 * Could later refactor to update search progress one at a time.
                 */

                this.searchRegion.show( new LoadingPredefinedSearchesView({
                    channel: this.channel
                }));

            }


        }
        else {

           this.searchRegion.hasView() && this.searchRegion.reset();

        }

        // Results:
        if ( !searchPerformed ) {

            // If cancel:
            this.resultsRegion.hasView() && this.resultsRegion.reset();
            return;
        }


        /**
         * for large table rendering, at least always show loading indicator for the hits table view in the results.
         * in future and depending on feedback, may wanto to make more fine-grained loading -- eg:
         * show loading view for the results table, which may be large -- but await feedback on current
         */

        this.resultsRegion.once( 'show', function()  {

            requestAnimationFrame( function() {
                channel.trigger('findAndRedact:hideSpinner');
            });

        });


        requestAnimationFrame( function() {

            channel.trigger('findAndRedact:showSpinner');

            requestAnimationFrame( function() {

                this.resultsRegion.show( new ResultsView({
                    channel: this.channel
                }));

            }.bind( this) );


        }.bind(this) );



    }



});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/layout.js
 ** module id = 586
 ** module chunks = 0
 **/